import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ff9dc01e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ff9dc01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9dc01e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff9dc01e')) {
      api.createRecord('ff9dc01e', component.options)
    } else {
      api.reload('ff9dc01e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ff9dc01e&scoped=true&", function () {
      api.rerender('ff9dc01e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4yzlc7JZuBXQ4/JS/comp/PopupBox.vue"
export default component.exports